var link_viewer_default = {
  "fontElementMap": "uyOCn",
  "link": "VilAY",
  "linkInEditor": "j9Igc",
  "linkInViewer": "W6jGu",
  "toolbarUrlContainer": "_13X1r",
  "toolbarUrl": "V7Y5T",
  "toolbarUrlAnchor": "_35dZJ"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
